export default __webpack_public_path__ + "static/thumb-16-df899efd8d4f359443bbfa2025ad7b82.jpg";